module.exports = __webpack_public_path__ + "static/p-logo--ecorigin-bed20f4ce8d4e50d53c1df8f3e9e4dd2.png";